import './TeamContainer.css'
import { useEffect, useState } from 'react'
import TeamHeader from '../TeamHeader/TeamHeader'
import TeamBubbles from '../TeamBubbles/TeamBubbles'
import axios from 'axios'
import { useAppContext } from '../../../../context/AppState/AppContext'

export default function TeamContainer() {
   const {jsonTexts} = useAppContext();
   const {title, subtitle, secondSubtitle, directors, staff, professorStaff} = jsonTexts.inicio.teamContainer;
   const [isLoading, setIsLoading] = useState(false)
   const [forVetTeam, setForVetTeam] = useState([])

   useEffect(() => {
      setIsLoading(true)
      const url = process.env.REACT_APP_BACKEND_SERVER + '/info/staff'
      axios.get(url)
         .then(response => setForVetTeam(response.data))
         .catch(err => console.log(err))
         .finally(() => setIsLoading(false))
   }, [])

   return (
      <section className='team-container'>
         <div className='team-first-container'>
            <TeamHeader title={title} subtitle={subtitle} secondSubtitle={secondSubtitle} />
            {forVetTeam?.directors?.length !== 0 && <div className='team-title-bubble-group'>
               <h3>{directors}</h3>
               < TeamBubbles team={forVetTeam?.directors} isLoading={isLoading} />
            </div>}
            {forVetTeam?.staff?.length !== 0 && <div className='team-title-bubble-group'>
               <h3>{staff}</h3>
               <TeamBubbles
                  team={forVetTeam?.staff
                     ?.filter(item => item.forVetRole
                        && item.forVetRole.length > 0
                     )}
                  isLoading={isLoading}
               />
            </div>}
            {forVetTeam?.teachers?.length !== 0 && <div className='team-title-bubble-group'>
               <h3>{professorStaff}</h3>
               <TeamBubbles team={forVetTeam?.teachers} isLoading={isLoading} hasToChange />
            </div>}
         </div>
      </section>
   )
}